module.exports = __webpack_public_path__ + "img/img32.5d378ee7.png";